module.exports = __webpack_public_path__ + "static/media/ding.4dd02c4e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/ding.mp3
// module id = 169
// module chunks = 29